import { css } from '@emotion/react';

export const styDomain = css({
  display: 'block',
  '&>div': {
    maxWidth: 200,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  '@media (max-width: 1050px)': {
    display: 'none',
  },
});
